<template>
  <div>
    <div class="breadcrumb-list d-flex justify-content-between">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Schedules</li>
      </ol>
      <a href="javascript:void(0);" @click="createNewScheduleFun" class="btn btn-primary"><i
        class="ico-plus mr-5"></i><span>Create New Schedule</span></a>
    </div>
    <div class="main-box dashboard-page">
      <div class="card-box ">
        <!--                <div class="card border-dark cardHeadCus" v-for="(item,key) in info.previousSchedules" v-if="info.previousSchedules.length>0" >
                          <router-link class="wrp-link" :to="'/schedule/publish/'+item.id+'/weeks'" :title="item.name"></router-link>
                          <div class="card-head bg-dark">
                              <h3>Previous & Published Schedule </h3>
                          </div>
                          <div class="card-body">
                              <strong class="cd-date">{{ item.start_date | moment("MMMM  D") }} to {{ item.end_date | moment("MMMM  D") }}</strong>
                          </div>
                        </div>-->
        <div class="card  cardHeadCus" style="border: #f5a623" v-for="(item,key) in info.editedSchedules"
             v-if="info.editedSchedules.length>0">
          <i @click="deleteSchedule(item.id)" v-if="removeBtn" class="fa fa-remove fa-remove-custom">&#xf00d;</i>
          <router-link class="wrp-link" :to="'/schedule/'+item.id" :title="item.name"></router-link>
          <div class="card-head " style="background: #f5a623">
            <div class="cusLoader">
              <clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
            </div>
            <h3><strong class="d-block mb-5 text-capitalize">{{ (item.name) ? item.name : 'Unnamed' }}</strong> Schedule
              is being edited</h3>
          </div>
          <div class="card-body">
            <strong class="cd-date">{{ item.start_date | moment("MMMM  D") }} to {{
                item.end_date | moment("MMMM  D ")
              }}</strong>
          </div>

        </div>
        <div class="card border-blue cardHeadCus" v-for="(item,key) in currentSchedules"
             v-if="currentSchedules.length>0">
          <!--                  <i @click="deleteSchedule(item.id)" class="fa fa-remove fa-remove-custom">&#xf00d;</i>-->
          <router-link class="wrp-link" :to="'/schedule/publish/'+item.id+'/weeks'" :title="item.name"></router-link>
          <div class="card-head bg-blue">
            <h3><strong class="d-block mb-5 text-capitalize">{{ (item.name) ? item.name : 'Unnamed' }}</strong> Current
              & Published Schedule </h3>
            <div class="custom-control custom-checkbox card-checkbox" title="Auto create this schedule for next period">
              <input type="checkbox" class="custom-control-input" :class="{'unchecked':isUnchecked==true}"
                     @change="updateData(item.id,item.is_auto_creation_schedule)"
                     v-model="item.is_auto_creation_schedule"
                     :id="'customCheck'+item.id">
              <label class="custom-control-label" :for="'customCheck'+item.id"></label>
            </div>
          </div>
          <div class="card-body">
            <strong class="cd-date">{{ item.start_date | moment("MMMM  D") }} to {{
                item.end_date | moment("MMMM  D ")
              }}</strong>
            <span class="cd-text" v-if="item.schedules.length>0"><router-link
              :to="'/schedule/publish/'+item.id+'/weeks/?free=true'">{{ item.schedules.length }} available</router-link> shift this week</span>
          </div>
        </div>
        <div class="card border-orange cardHeadCus" v-for="(item,key) in info.upcomingSchedules">
          <!--                  <i @click="deleteSchedule(item.id)" class="fa fa-remove fa-remove-custom">&#xf00d;</i>-->
          <router-link class="wrp-link" :to="'/schedule/publish/'+item.id+'/weeks'" :title="item.name"></router-link>
          <div class="card-head bg-orange">

            <h3><strong class="d-block mb-5 text-capitalize">{{ (item.name) ? item.name : 'Unnamed' }}</strong> Upcoming
              & Published Schedule </h3>
            <div class="custom-control custom-checkbox card-checkbox" title="Auto create this schedule for next period">
              <input type="checkbox" class="custom-control-input"
                     @change="updateData(item.id,item.is_auto_creation_schedule)"
                     v-model="item.is_auto_creation_schedule"
                     :id="'customCheck'+item.id">
              <label class="custom-control-label" :for="'customCheck'+item.id"></label>
            </div>
          </div>
          <div class="card-body">
            <strong class="cd-date">{{ item.start_date | moment("MMMM  D") }} to {{
                item.end_date | moment("MMMM  D")
              }}</strong>
          </div>

        </div>
        <div class="card border-gray cardHeadCus" v-for="(item,key) in info.unPublishedSchedules"
             v-if="info.unPublishedSchedules.length>0">
          <i @click="deleteSchedule(item.id)" v-if="removeBtn" class="fa fa-remove fa-remove-custom"></i>
          <router-link class="wrp-link" :to="'/schedule/'+item.id" :title="item.name"></router-link>
          <div class="card-head bg-gray ">
            <div class="cusLoader">
              <clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
            </div>
            <h3><strong class="d-block mb-5 text-capitalize">{{ (item.name) ? item.name : 'Unnamed' }}</strong>
              Unpublished Schedules </h3>
          </div>
          <div class="card-body">
            <strong class="cd-date">{{ item.start_date | moment("MMMM  D") }} to {{
                item.end_date | moment("MMMM  D")
              }}</strong>
          </div>
        </div>
        <div class="card border-blue">
          <div class="card-body add-new">
            <a class="wrp-link" href="javascript:void(0);" @click="createNewScheduleFun">
              <i class="ico-plus"></i>
              <span>Create New Schedule</span>
            </a>
          </div>
        </div>
      </div>
      <div class="mb-20" >
        <a href="javascript:void(0);" v-if="info.previousSchedules" class="btn btn-primary"
           @click="previousScheduleBtn"><span>Previous Schedules</span></a>
      </div>
      <div v-show="isPreviousSchedule">
        <div class="card-box-row" v-for="(schedules,key) in info.previousSchedules" :key="key">
          <div class="border-bottom mb-15 pb-10">
            <h2 class="mb-0">{{ key }} </h2>
          </div>
          <div class="card-box ">
            <div class="card border-dark cardHeadCus" v-for="(item,index) in schedules" :key="index">
              <router-link class="wrp-link" :to="'/schedule/publish/'+item.id+'/weeks'"
                           :title="item.name"></router-link>
              <div class="card-head bg-dark">
                <h3><strong class="d-block mb-5 text-capitalize">{{ (item.name) ? item.name : 'Unnamed' }}</strong>
                  Previous & Published Schedule </h3>
              </div>
              <div class="card-body">
                <strong class="cd-date">{{ item.start_date | moment("MMMM  D") }} to
                  {{ item.end_date | moment("MMMM  D") }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div>
          <a href="javascript:void(0);" class="btn btn-outline-primary" @click="loadMoreRoasters">Load more</a>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../router/router'
import axios from "axios";
import Swal from "sweetalert2";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Multiselect from "vue-multiselect";

export default {
  components: {ClipLoader},
  data() {
    return {
      loading: false,
      removeBtn: true,
      spinnerColor: '#c01111',
      item: {
        is_auto_creation_schedule: '',
      },
      isPreviousSchedule: false,
      isUnchecked: false,
      info: [],
      currentSchedules: [],
      company_id: this.$store.getters.getSelectedCompany.id,
      page: 0,
      size: null
    }
  },
  serverPrefetch() {
  },
  created() {
    if (this.company_id) {
      this.getSchedules();
    }
  },
  mounted() {
    this.$root.$emit('activeCompoClick');
    this.$root.$on("reloadDashboardOnChangeComp", () => {
      this.$router.go(0);
    });
  },
  methods: {
    loadMoreRoasters() {
      this.page++;
      let params = {company_id: this.company_id, page: this.page}
      this.$axios
        .get(this.$API_URL + 'api/dashboard-prev-roasters', {
          params: params,
          headers: this.getAuthHeader()
        })
        .then(response => {
          this.info.previousSchedules = {...this.info.previousSchedules, ...response.data.result}
         // console.log(response.data.result, 'this.infoesadsad ');

        });
    },
    previousScheduleBtn() {
      this.isPreviousSchedule = true
    },

    updateData(id, value) {
      if (value === true) {
        var isAutoCreate = 1;
        var message = 'Are you sure you want to auto create this schedule for next?';
      } else {
        var isAutoCreate = 0;
        var message = 'Are you sure you want to stop auto create this schedule for next?';
      }
      new Swal({
        title: "Sure?",
        icon: "info",
        text: message,
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes"
      }).then((result) => {
        if (result.value) {
          axios.post(this.$UpdateRosterSchedule,
            {
              is_auto_creation_schedule: isAutoCreate,
              id: id,
            }, {headers: this.getAuthHeader()})
            .then((res) => {
              if (res.data.status == 200) {
                $root.$toast.success("Updated successfully");
              }
            });
        } else {
          if (value === true) {
            $("#customCheck" + id).prop("checked", false);
          } else {
            $("#customCheck" + id).prop("checked", true);
          }

        }
      })

    },
    //------------------ delete schedule ----------------/
    deleteSchedule(id) {
      new Swal({
        title: "Delete?",
        icon: "warning",
        text: "Do you really want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.removeBtn = false;
          let params = {company_id: this.company_id, id: id};
          this.$axios
            .get(this.$ScheduleTemplateDelete, {
              params: params,
              headers: this.getAuthHeader()
            })
            .then(response => {
              this.loading = false;
              this.removeBtn = true;
              if (response.status == 200) {
                this.getSchedules();
              }
            })
            .catch(error => {
              console.log(error);
            })
        }
      });

    },
    createNewScheduleFun() {
      localStorage.setItem('isPageOverlayer', true);
      this.$router.push('/schedule');
    },
    getSchedules() {

      let params = {company_id: this.company_id}
      this.$axios
        .get(this.$API_URL + 'api/dashboard', {
          params: params,
          headers: this.getAuthHeader()
        })
        .then(response => {
          this.currentSchedules = response.data.result.currentSchedules || []
          this.info = response.data.result || []
        })
        .catch(error => {
          console.log(error);
        })
    },
  }
}
</script>

<style>
.card-checkbox.custom-control {
  position: absolute;
  right: 3px;
  top: 10px;
  z-index: 2;
}

.card-box .card-head {
  padding: 13px 37px 13px 20px;
}

.card-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #9cb1c7;
  background-color: #9cb1c7;
}

i.fa-remove-custom {
  position: absolute;
  font-size: 18px;
  top: 2px;
  right: 2px;
  cursor: pointer;
  color: red;
  display: none;
}

.cardHeadCus:hover .fa-remove-custom {
  font-size: 18px;
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  color: red;
  display: block;
}
.cusLoader{
  top: 0px;
  position: absolute;
  right: 0;
}
</style>
